module.exports = __webpack_public_path__ + "static/media/call.536cd58e.jpeg";